import React from 'react'

const About = () => {
  return (
    <div className="about">
        <h2 className="header small">About Questify</h2>
        <p>Questify is a free web application that keeps track of your tasks and helps boost your productivity. It is built with React and makes use of your browser's local storage to store the tasks. The github repository can be found <a href="https://github.com/sibashis12/crackedlotus" target="_blank" rel="noreferrer">here</a>. Made by <a href="https://linkedin.com/in/sibashis12" target="_blank" rel="noreferrer">Sibashis Som</a>.</p>
    </div>
  )
}

export default About